module.exports = __webpack_public_path__ + "img/T7A6671.aa8791a1.jpg";